import { routes } from '~/components/app/appMainRoutes';

export const settingsRoutes = {
  settingsIndexRoute: '/settings',
  generalAccountRoute: '/settings/general/account',
  generalTeamsRoute: '/settings/general/teams',
  generalNotificationsRoute: '/settings/general/notifications',
  generalBillingRoute: '/settings/general/billing',
  teamGeneralRoute: '/settings/team/general',
  teamUsersRoute: '/settings/team/users',
  teamNotificationsRoute: '/settings/team/notifications',
  productsTargetMarketRoute: '/settings/products/target-market',
  productsVisitorReportRoute: '/settings/products/visitor-report',
  apiKeysRoute: '/settings/api/keys',
  apiLogsRoute: '/settings/api/logs',
  apiUsageRoute: '/settings/api/usage',
  apiDocsRoute: 'https://dashboard.clearbit.com/docs',
  configureHubspot: '/settings/configuration/hubspot',
  tagsJs: routes.tagsJs,
  hubSpotIntegration: '/settings/configuration/hubspot',
};
